module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMjcuMjAwOCAxNi4wMDA1QzI3LjIwMDggMTQuODA2MyAyNi4xMzQxIDE0LjQwMDUgMjYuMTM0MSAxNC40MDA1TDQuODAwNzggNS44NjcxOUw4LjY0NDU0IDE0Ljk5ODRMMTguNjY3NCAxNi4wMDA1TDguNjQ0NTQgMTcuMDAyNkw0LjgwMDc4IDI2LjEzMzlMMjYuMTM0MSAxNy42MDA1QzI2LjEzNDEgMTcuNjAwNSAyNy4yMDA4IDE3LjE5NDggMjcuMjAwOCAxNi4wMDA1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./assets/assistant-button.svg
// module id = ./assets/assistant-button.svg
// module chunks = 10